import { createBrowserRouter } from 'react-router-dom';
import { RootLayout } from './components/layout/root-layout';
import { ModernHomePage } from './pages/modern-home';
import { ModernProductsPage } from './pages/modern-products';
import { ModernCategoriesPage } from './pages/modern-categories';
import { ModernProductDetailPage } from './pages/modern-product-detail';
import { CartPage } from './pages/cart';
import { ModernWishlistPage } from './pages/modern-wishlist';
import { SettingsPage } from './pages/settings';
import { TrackPage } from './pages/track';
import { AboutPage } from './pages/about';
import { ContactPage } from './pages/contact';
import { OrderCompletePage } from './pages/order-complete';
import { FAQPage } from './pages/faq';
import { ReturnPolicyPage } from './pages/return-policy';
import { PrivacyPolicyPage } from './pages/privacy-policy';
import { TermsOfServicePage } from './pages/terms-of-service';
import { NewStripePaymentPage } from './pages/stripe-payment-new';

export const router = createBrowserRouter([
  {
    path: '/',
    element: <RootLayout />,
    children: [
      { index: true, element: <ModernHomePage /> },
      { path: 'home', element: <ModernHomePage /> },
      { path: 'products', element: <ModernProductsPage /> },
      { path: 'product/:id', element: <ModernProductDetailPage /> },
      { path: 'cart', element: <CartPage /> },
      { path: 'settings', element: <SettingsPage /> },
      { path: 'categories', element: <ModernCategoriesPage /> },
      { path: 'wishlist', element: <ModernWishlistPage /> },
      { path: 'track', element: <TrackPage /> },
      { path: 'about', element: <AboutPage /> },
      { path: 'contact', element: <ContactPage /> },
      { path: 'order-complete', element: <OrderCompletePage /> },
      { path: 'stripe-payment', element: <NewStripePaymentPage /> },
      { path: 'faq', element: <FAQPage /> },
      { path: 'return-policy', element: <ReturnPolicyPage /> },
      { path: 'privacy-policy', element: <PrivacyPolicyPage /> },
      { path: 'terms-of-service', element: <TermsOfServicePage /> },
    ],
  },
]);